/* global Browser */
import tilt from 'vanilla-tilt';
import { elHTML } from '../config/vars';
export default class ParallaxCover {

  constructor (el) {

    this.el = el;

    if (Browser.isIE || !elHTML.classList.contains('no-touchevents')) {

      return;
    }

    this.parallax = tilt.init(el, {
      max: 10,
      speed: 1500,
      perspective: 400,
      scale: 1.05,
      glare: true,
      'max-glare': 0.5
    });
  }
}
